﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederNordenDto from '../Models/VeilederNordenDto';

const hele = 'a1-varighetValgHeltAar';
const host = 'a2-varighetValgHost';
const vaar = 'a3-varighetValgVaar';

const varighetValg: RadioButtonValgModel<VeilederNordenDto>[] = [
    {
        id: 'norden-a1',
        value: hele,
        tekst: 'varighetValgHeltAar',
    },
    {
        id: 'norden-a2',
        value: host,
        tekst: 'varighetValgHost',
    },
    {
        id: 'norden-a3',
        value: vaar,
        tekst: 'varighetValgVaar',
    }
];

export default {
    a1_hele: hele,
    a2_host: host,
    a3_vaar: vaar,
    varighetValg,
};
